import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";
import { Ref, ref } from "@vue/composition-api";

export const tableConfig: Ref<ITableConfig> = ref({
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Email",
      key: "email",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "8rem",
      spanMax: "1.5fr",
    },
    {
      name: "Role",
      key: "role",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    },
    {
      name: "Information Scope",
      key: "info_types",
      sortable: false,
      filterable: false,
      spanMin: "12rem",
      spanMax: "1fr",
    },

    {
      name: "Status",
      key: "status",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    },
    /*  {
      name: "Permissions",
      key: "permissions",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "6rem",
      spanMax: "1fr",
    }, */
    /*  {
      name: "Action",
      key: "actions",
      sortable: false,
      filterable: false,
      spanMin: "4rem",
      spanMax: "4rem",
    }, */
  ],
});
